import { Box } from "@saleor/macaw-ui-next";
import { ReactNode } from "react";

import { topBarHeight, topBarHeightSubtitle } from "../consts";

export const TopNavWrapper = ({
  children,
  withoutBorder,
  hasSubtitle,
}: {
  withoutBorder?: boolean;
  children: ReactNode;
  hasSubtitle?: boolean;
}) => (
  <Box
    display={hasSubtitle ? "block" : "flex"}
    alignItems="center"
    paddingX={6}
    paddingY={5}
    borderBottomWidth={withoutBorder ? 0 : 1}
    borderBottomStyle="solid"
    borderColor="default1"
    position="relative"
    data-test-id="page-header"
    __height={hasSubtitle ? topBarHeightSubtitle : topBarHeight}
    gridColumn="8"
    gridRowStart="1"
    backgroundColor="default1"
  >
    {children}
  </Box>
);
